
    import __i18nConfig from '@next-translate-root/i18n'
    import __loadNamespaces from 'next-translate/loadNamespaces'
    import { GetStaticPaths, GetStaticProps } from 'next/types';
import { SUPPORTED_LOCALES, SUPPORTED_LOCALES_STRINGS, SupportedLocale, } from 'i18n';
import { groq } from 'next-sanity';
import { Converter } from 'showdown';
import { BlogArticlePage } from 'modules/blog/pages/BlogArticlePage';
import { getClient } from '../../../../lib/sanity.server';
import { MarketplaceAPI } from 'revibe-api';
export default BlogArticlePage;
export const getStaticPaths: GetStaticPaths = async () => {
    const [enCategories, frCategories, itCategories] = await Promise.all(SUPPORTED_LOCALES_STRINGS.map(async (locale) => await MarketplaceAPI.getBlogCategories(locale)));
    const [enSlugs, frSlugs, itSlugs] = await Promise.all(SUPPORTED_LOCALES_STRINGS.map(async (locale) => await MarketplaceAPI.getBlogArticles(locale)));
    const paths: {
        params: {
            slug: string;
            category: string;
        };
        locale: string;
    }[] = [];
    enSlugs.data &&
        enSlugs.data.forEach(({ slug }) => enCategories.data &&
            enCategories.data.forEach((category) => paths.push({
                params: { slug, category: category.slug },
                locale: SUPPORTED_LOCALES.EN,
            })));
    frSlugs.data &&
        frSlugs.data.forEach(({ slug }) => frCategories.data &&
            frCategories.data.forEach((category) => paths.push({
                params: { slug, category: category.slug },
                locale: 'fr',
            })));
    itSlugs.data &&
        itSlugs.data.forEach(({ slug }) => itCategories.data &&
            itCategories.data.forEach((category) => paths.push({
                params: { slug, category: category.slug },
                locale: 'it',
            })));
    return {
        paths,
        fallback: 'blocking',
    };
};
const getStaticProps: GetStaticProps = async ({ params, locale }) => {
    const query = groq `*[_type == "comment" && article == $slug]`;
    const queryParams = { slug: params?.slug as string };
    const comments = await getClient(false).fetch(query, queryParams);
    const { data: dbArticle } = await MarketplaceAPI.getDBBlogArticle({
        slug: params?.slug as string,
        token: process.env.REVIBE_API_TOKEN as string,
    });
    const { data: article } = await MarketplaceAPI.getBlogArticle(params?.slug as string, locale as SupportedLocale);
    const { data: categories } = await MarketplaceAPI.getBlogCategories((locale as SupportedLocale) || SUPPORTED_LOCALES.EN);
    const { data: slugs } = await MarketplaceAPI.getAllBlogArticlesSlugs(locale as SupportedLocale);
    let previous: MarketplaceAPI.BlogArticle | null = null;
    let next: MarketplaceAPI.BlogArticle | null = null;
    if (slugs) {
        const index = slugs.findIndex((s) => s.slug === (params?.slug as string));
        previous = slugs[index - 1] || null;
        next = slugs[index + 1] || null;
    }
    if (article) {
        const converter = new Converter();
        const html = converter.makeHtml(article.content);
        article.html = html;
    }
    return {
        props: {
            article: { ...article, likes: dbArticle?.likes || 0, previous, next },
            comments,
            categories,
        },
        revalidate: 60,
    };
};

    async function __Next_Translate__getStaticProps__18c6845d6fb__(ctx) {
      const res = await getStaticProps(ctx)
      return {
        
        ...res,
        props: {
          ...(res.props || {}),
          ...(await __loadNamespaces({
            ...ctx,
            ...__i18nConfig,
            pathname: '/blog/[category]/[slug]/index',
            loaderName: 'getStaticProps',
            loadLocaleFrom: (l, n) => import(`@next-translate-root/locales/${l}/${n}`).then(m => m.default),
          }))
        }
      }
    }
    export { __Next_Translate__getStaticProps__18c6845d6fb__ as getStaticProps }
  